import { useState } from "react";
import { Box, Flex, Icon, Spinner, Text } from "@storyofams/react-ui";
import { useShopify } from "~context";
import { showToast } from "~lib";
import { User } from "~components/common/Icons";

export const TypeSwitch = ({ ...props }) => {
  const { isB2B, updateCustomerType, refetchCustomer } = useShopify();
  const [isCustomerUpdating, setIsCustomerUpdating] = useState(false);
  const handleSwitch = async () => {
    try {
      setIsCustomerUpdating(true);
      await updateCustomerType();
      refetchCustomer();
    } catch {
      showToast("error", "error");
    } finally {
      setIsCustomerUpdating(false);
    }
  };
  return (
    <Box
      order={[0, 1]}
      py={1}
      mb={[2, 0]}
      height={"max-content"}
      px={2}
      borderRadius={"8px"}
      backgroundColor={"#FCF9F7"}
      lineHeight={"22px"}
      textAlign={["start", "end"]}
      width={["100%", "max-content"]}
      {...props}
    >
      {isCustomerUpdating ? (
        <Spinner my={2} />
      ) : (
        <>
          <Flex mb={1}>
            <Icon mr={1} fontSize={2} icon={User}></Icon>
            <Text>
              {isB2B
                ? "Je bent ingelogd als groothandel klant"
                : "Je bent ingelogd als consument"}
            </Text>
          </Flex>
          <Text
            cursor={"pointer"}
            textDecoration={"underline"}
            fontWeight={600}
            fontSize={2}
            lineHeight={"140%"}
            onClick={handleSwitch}
          >
            {isB2B
              ? "Schakel over naar jouw consument account"
              : "Schakel over naar jouw groothandel account"}
          </Text>
        </>
      )}
    </Box>
  );
};
